<template>
    <v-card class="pa-4 pa-md-6">
        <div class="d-flex align-start mb-6 text-black">
            <div class="notification-dialog__title">
                {{ t('common.resources.informationAboutDeparture', 'Information about departure') }}
            </div>
            <v-spacer />
            <v-icon size="30" icon="mdi-close-circle" @click="close" />
        </div>

        <v-sheet v-for="message in modelValue" :key="message.id" color="grey-lighten-3" rounded="lg" class="pa-3 pa-md-4 mb-4 mb-md-6">
            <notification-badge :model-value="message" />
            <div class="notification-dialog__message mt-2" v-html="getNotificationText(message)" />
        </v-sheet>

        <v-card-actions v-if="!isMobile" class="pa-0">
            <v-spacer />
            <v-btn variant="flat" color="primary" size="large" @click="close">
                <span class="text-h6 font-weight-bold">{{ t('common.resources.back', 'Back') }}</span>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { NotificationMessageDto } from '@/types/webapi';
import { useI18n } from 'vue-i18n';
import { NotificationBadge } from '.';
import { useNotificationMessage } from './NotificationMessagesList/useNotificationMessage';

interface Props {
    modelValue: NotificationMessageDto[];
}

interface Emits {
    (e: 'click-close'): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const { mobile: isMobile } = useDisplay();
const { t } = useI18n();
const { getNotificationText } = useNotificationMessage();

function close() {
    emit('click-close');
}
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'sass:map';

.notification-dialog {
    &__title {
        font-size: calc(20px / $font-size-root) * 1rem;
        line-height: calc(30px / 24px);
        font-weight: 700;

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            font-size: calc(24px / $font-size-root) * 1rem;
        }
    }

    &__message {
        font-size: calc(16px / $font-size-root) * 1rem;

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            font-size: calc(18px / $font-size-root) * 1rem;
        }
    }
}
</style>
